import CapabilitiesPuppeteer from './../src/capabilities/puppeteer.js'
window.capabilitiesPuppeteer = new CapabilitiesPuppeteer()
